import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { filter } from 'rxjs/operators';
import { HomeService } from '../_services/home.service';
import { HeaderSearchService } from '../_services/header-search.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { auto } from '@popperjs/core';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileService } from '../_services/user-profile.service';
import { ErrorMessageService } from '../services/error-message.service';
import { ToastrService } from 'ngx-toastr';
import { SeoService } from '../seo.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // Ensures c
})

export class HeaderComponent implements OnInit {

  @ViewChild('searchkey') searchInput: ElementRef;
  constructor(private route: ActivatedRoute,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private homeService: HomeService,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private userProfileService: UserProfileService,
    private errorMessageService: ErrorMessageService,
    private toastr: ToastrService,
    private searchService: HeaderSearchService,
    private seoService: SeoService) {
    // this.searchCity()
    const storedCityName = localStorage.getItem('selectedCityName');
    if (storedCityName) {
      this.searchCityQuery = storedCityName;
    }
  }
  searchTerm = 'artwork';
  dropdownOpen = false;
  usertoken: any = [];
  token = '';
  userinfo: any = [];
  socialOrigin = '';
  itsMe = true;
  userid = '';
  unReadCount = 0;
  isDropdownOpen: boolean = false
  collapsed: boolean = false
  builder: boolean | string = '';
  individual: boolean | string = '';
  auths: boolean | string = '';

  popularCities: any = [];
  otherCities: any = [];
  // collapsed3:boolean = false
  collapsed1: boolean = false;
  isKhubiiAdmin = false;
  isMenushow: boolean = false
  userfullname: string = '';
  useremail = '';
  @ViewChild('navbarToggler') navbarToggler: ElementRef;


  populateForm() {
    const profileData = localStorage.getItem('UserProfile');
    console.log('profileData', profileData);

    if (profileData) {
      this.userfullname = JSON.parse(profileData)?.payload?.fullName;
      this.adminlogo = JSON.parse(profileData)?.payload?.adminLogo;
      this.builder = JSON.parse(profileData)?.payload?.builder;
      this.individual = JSON.parse(profileData)?.payload?.individual;
      this.useremail = JSON.parse(profileData)?.payload?.email;
      this.cdr.detectChanges();
    }
  }
  loginPopup() {
    this.dialog.open(LoginPopupComponent, {
      width: '380px',
      height: auto
    });
  }
  navigateTologin() {
    this.loginPopup()
  }
  adminlogo: any
  ngOnInit(): void {

    this.headercity();
    this.userProfileService.userProfile$.subscribe(profile => {
      if (profile) {
        this.userfullname = profile.payload?.fullName || profile?.fullName;
        this.adminlogo = profile?.adminLogo
        console.log("this.adminlogo", this.adminlogo)
        this.useremail = profile.payload?.email || profile?.email;
        this.builder = profile.payload?.builder || profile?.builder;
        this.individual = profile.payload?.individual || profile?.individual;
        this.cdr.detectChanges(); // Ensures UI updates properly
      }
    });
  }
menuOpen = false;

onMenuOpened() {
  this.menuOpen = true;
}

onMenuClosed() {
  this.menuOpen = false;
}


  navBarTogglerIsVisible() {
    return this.navbarToggler?.nativeElement.getAttribute('aria-expanded')
  }
  @ViewChild('navbarToggler1') navbarToggler1: ElementRef;
  navBarTogglerIsVisible1() {
    return this.navbarToggler1?.nativeElement.getAttribute('aria-expanded')
  }
  navigateToUserProprty() {

    this.router.navigate(['/UserProperty'])
  }
  // 	navigateToUserProprty() {

  // 	this.router.navigate(['/my-property'])
  // }
  navigateToUserProjects() {

    this.router.navigate(['/myprojects'])
  }
  // popularCities = [
  //   { name: 'Ahmedabad' }, { name: 'Bangalore' }, { name: 'Chennai' }, { name: 'Gurgaon' },
  //   { name: 'Hyderabad' }, { name: 'Indore' }, { name: 'Jaipur' }, { name: 'Kolkata' },
  //   { name: 'Lucknow' }, { name: 'Mumbai' }, { name: 'Navi Mumbai' }, { name: 'New Delhi' },
  //   { name: 'Noida' }, { name: 'Pune' }, { name: 'Thane' }
  // ];

  // otherCities = [
  //   { name: 'Agra' }, { name: 'Aurangabad' }, { name: 'Amritsar' }, { name: 'Ahmednagar' },
  //   { name: 'Aluva' }, { name: 'Bhopal' }, { name: 'Bhiwandi' }, { name: 'Bareilly' },
  //   { name: 'Chandigarh' }, { name: 'Dheradun' }, { name: 'Faridabad' }, { name: 'Goa' },
  //   { name: 'Greater Noida' }, { name: 'Kanpur' }, { name: 'Kalyan' }, { name: 'Ludhiyana' },
  //   { name: 'Nagpur' }, { name: 'Patna' }, { name: 'Ranchi' }, { name: 'Satara' },
  //   // Add more...
  // ];

  headercity() {
    this.homeService.headercity().subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          const allCities = response.payload;

          // First 10 cities → Popular
          this.popularCities = allCities.slice(0, 10);

          // Remaining → Other
          this.otherCities = allCities.slice(10);
        } else {
          const errorMessage = this.errorMessageService.getErrorMessage('Failed to fetch city data');
          this.toastr.error(errorMessage, 'Error');
        }
      },
      (error) => {
        const message = error?.error?.message || 'Failed to fetch city data';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }










  // toggleDropdown() {
  // 	this.dropdownOpen = !this.dropdownOpen;
  // }
  // toggleDropdowns() {
  // 	this.isDropdownOpen = !this.isDropdownOpen;
  // }	// toggleDropdown() {
  // 	this.dropdownOpen = !this.dropdownOpen;
  // }
  // toggleDropdowns() {
  // 	this.isDropdownOpen = !this.isDropdownOpen;
  // }
  selectOption(option: string) {
    this.dropdownOpen = false;
  }


  searchArt() {
    const searchData = this.searchInput.nativeElement.value;
    this.searchService.setSearchData(searchData);
  }



  userLogout() {
    this.tokenStorage.signOut();
    this.router.navigate(['/login']).then(() => {
      window.location.reload();
    });
  }
  newsnavigate() {
    this.router.navigate(['/news']).then(() => {
      //   window.location.reload();

      let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
    });
  }
  loginnavigate() {
    this.router.navigate(['/login'])
  }
  projectnavigate() {
    this.router.navigate(['/add-project'])
  }
  propertynavigate() {
    // this.router.navigate(['/add-property'])
    this.router.navigate(['/add-listing'])

  }

  rentAgreementNavigate() {
    this.router.navigate(['/rent-agreement'])
  }
chnagepassword(){
    const email =this.useremail;
    this.router.navigate(['/resetpassword'], { queryParams: { email } });
}
  isMobileMenuOpen = false;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  isHovering: boolean = false;
  inputFocused: boolean = false;

  onInputFocus() {
    this.inputFocused = true;
    this.showCitySuggestions = true;
  }

  onInputBlur() {
    this.inputFocused = false;
    // setTimeout(() => {
    this.maybeHideSuggestions();
    // }, 200);
  }

  maybeHideSuggestions() {
    if (!this.inputFocused && !this.isHovering) {
      this.showCitySuggestions = false;
    }
  }

  onCityInputClick() {
    if (this.popularCities.length > 0) {
      this.showCitySuggestions = true;
    }
  }
  onMouseEnter() {
    this.isHovering = true;
    this.showCitySuggestions = true;
  }


  clearSearch() {
    this.searchTerm = '';
  }

  selectedCityId: string | null = null;
  searchCityQuery: string = 'Gurgaon';
  cityDataList: any[] = [];
  allstateId: any
  showCitySuggestions: boolean = false
  searchQuery: any

  // searchCity(searchTerm: string = '') {
  //   if (this.selectedCityId) {
  //     this.selectedCityId = null;
  //     this.searchCityQuery = searchTerm;
  //   }

  //   this.homeService.searchCity(searchTerm).subscribe(
  //     (response: any) => {
  //       if (response.status === 'SUCCESS') {
  //         this.cityDataList = response.payload;
  //       } else {
  //         console.error('Failed to fetch city data:', response);
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching city data:', error);
  //     }
  //   );
  // }


  selectedCityName: string | null = localStorage.getItem('selectedCityName');
  showDropdown(inputElement: HTMLInputElement) {
    this.onCityInputClick()
    this.showCitySuggestions = true;
    inputElement.focus();  // Ensure cursor stays in the input field
  }

  hideDropdown() {
    this.showCitySuggestions = false;
  }









  selectCity(city: any) {
    this.searchQuery = '';
    this.selectedCityId = city.id;
    this.allstateId = city.stateId;

    console.log('this.selectedCityId', this.selectedCityId);

    // Store city details in localStorage
    localStorage.setItem('allcityId', this.selectedCityId);
    localStorage.setItem('allstateId', this.allstateId);
    localStorage.setItem('selectedCityName', city.name);
    localStorage.setItem('selectedCityId', this.selectedCityId);
    this.seoService.applyDefaultMeta();
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
    this.searchCityQuery = city.name; // Set input value
    this.showCitySuggestions = false;
    // window.location.reload();
  }


  clearSearchdrop() {
    this.searchCityQuery = '';
    this.showCitySuggestions = false;
    // this.searchCity()

  }



  toggleDropdown(input: HTMLInputElement) {
    this.showCitySuggestions = !this.showCitySuggestions;
    if (this.showCitySuggestions) {
      setTimeout(() => input.focus(), 0);
    }
  }




}
